import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendUploadedDocumentsToFavorCockpitMutationVariables = Types.Exact<{
  request: Types.SendUploadedDocumentsToFavorCockpitInput;
}>;


export type SendUploadedDocumentsToFavorCockpitMutation = { __typename?: 'Mutation', sendUploadedDocumentsToFavorCockpit: number };


export const SendUploadedDocumentsToFavorCockpitDocument = gql`
    mutation sendUploadedDocumentsToFavorCockpit($request: SendUploadedDocumentsToFavorCockpitInput!) {
  sendUploadedDocumentsToFavorCockpit(request: $request)
}
    `;
export type SendUploadedDocumentsToFavorCockpitMutationFn = Apollo.MutationFunction<SendUploadedDocumentsToFavorCockpitMutation, SendUploadedDocumentsToFavorCockpitMutationVariables>;

/**
 * __useSendUploadedDocumentsToFavorCockpitMutation__
 *
 * To run a mutation, you first call `useSendUploadedDocumentsToFavorCockpitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendUploadedDocumentsToFavorCockpitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendUploadedDocumentsToFavorCockpitMutation, { data, loading, error }] = useSendUploadedDocumentsToFavorCockpitMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useSendUploadedDocumentsToFavorCockpitMutation(baseOptions?: Apollo.MutationHookOptions<SendUploadedDocumentsToFavorCockpitMutation, SendUploadedDocumentsToFavorCockpitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendUploadedDocumentsToFavorCockpitMutation, SendUploadedDocumentsToFavorCockpitMutationVariables>(SendUploadedDocumentsToFavorCockpitDocument, options);
      }
export type SendUploadedDocumentsToFavorCockpitMutationHookResult = ReturnType<typeof useSendUploadedDocumentsToFavorCockpitMutation>;
export type SendUploadedDocumentsToFavorCockpitMutationResult = Apollo.MutationResult<SendUploadedDocumentsToFavorCockpitMutation>;
export type SendUploadedDocumentsToFavorCockpitMutationOptions = Apollo.BaseMutationOptions<SendUploadedDocumentsToFavorCockpitMutation, SendUploadedDocumentsToFavorCockpitMutationVariables>;